import styles from "../styles/PushSubscriptionItem.module.scss";
import {useState} from "react";
import ToggleSwitch from "../../components/admin/sidebar/items/ToggleSwitch";
import {getDeviceStringFromUserAgent} from "./NotificationSettings";

export function NotificationItem(props: {
    push_subscription: PushSubscription,
    deletePushSubscription: (sub: PushSubscription) => void,
}) {
    const [on, setOn] = useState(true);

    function handleDelete() {
        setOn(false);
        setTimeout(() => props.deletePushSubscription(props.push_subscription), 500)
    }

    return <div className={styles.itemContainer}>
        <div>
            <span>{props.push_subscription.organization.title}</span>
            <span>{getDeviceStringFromUserAgent(props.push_subscription.user_agent)}</span>
            <small>App Notifications</small>
        </div>
        <div>
            <ToggleSwitch onClick={handleDelete} on={on} />
        </div>
    </div>
}